import {
  REPORT_AGENCY_PERFERMANCE_OVERVIEW_PATH,
  REPORT_FINANCIAL_ACCOUNT_REPORT_PATH,
  REPORT_FINANCIAL_ACCOUNT_SRECEIVABLE_SALES_JOURNAL_PATH,
  REPORT_FLASH_MANAGER_PATH,
  REPORT_TRIAL_BALANCE_PATH,
} from '@constants/Navigation/AppPaths/ReportPaths';
import { Box } from '@mui/material';
import { RootContextProps } from 'components/RootContainer';
import i18next from 'i18next';
import React, { FC } from 'react';
import { RouteObject, useRouteError } from 'react-router-dom';
import { Breadcrumb } from 'routing/components/Breadcrumb';
import LoadingPage from '../../../../../components/LoadingPage';
import AccountsReceivableSalesJournalReportPage from '../pages/AccountsReceivableSalesJournalReportPage';
import AgencyPerfermanceOverviewReportPage from '../pages/AgencyPerfermanceOverviewReportPage';
import FinancialAccountReportPage from '../pages/FinancialAccountReportPage';
import FlashManagerReportPage from '../pages/FlashManagerReportPage';
import TrialBalanceReportPage from '../pages/TrialBalanceReportPage';

const FrontdeskReportBoundary: FC = (): JSX.Element => {
  let error = useRouteError() as Error;
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',

        height: '100%',
      }}
    >
      <h2>Error : </h2>
      <p>{error.message}</p>
    </Box>
  );
};

export const reportFinancialRoutePaths = (api: RootContextProps): RouteObject[] => [
  {
    path: REPORT_FINANCIAL_ACCOUNT_SRECEIVABLE_SALES_JOURNAL_PATH,
    element: (
      <React.Suspense fallback={<LoadingPage />}>
        <AccountsReceivableSalesJournalReportPage />
      </React.Suspense>
    ),
    errorElement: <FrontdeskReportBoundary />,
    handle: {
      crumb: () => (
        <Breadcrumb
          label={i18next.t('report.menu.accounts_receivable_sales_journal' as any)}
          path={REPORT_FINANCIAL_ACCOUNT_SRECEIVABLE_SALES_JOURNAL_PATH}
        />
      ),
    },
  },
  {
    path: REPORT_FLASH_MANAGER_PATH,
    element: (
      <React.Suspense fallback={<LoadingPage />}>
        <FlashManagerReportPage />
      </React.Suspense>
    ),
    errorElement: <FrontdeskReportBoundary />,
    handle: {
      crumb: () => (
        <Breadcrumb
          label={i18next.t('report.menu.flash_manager' as any)}
          path={REPORT_FLASH_MANAGER_PATH}
        />
      ),
    },
  },
  {
    path: REPORT_TRIAL_BALANCE_PATH,
    element: (
      <React.Suspense fallback={<LoadingPage />}>
        <TrialBalanceReportPage />
      </React.Suspense>
    ),
    errorElement: <FrontdeskReportBoundary />,
    handle: {
      crumb: () => (
        <Breadcrumb
          label={i18next.t('report.menu.trial_balance' as any)}
          path={REPORT_TRIAL_BALANCE_PATH}
        />
      ),
    },
  },
  {
    path: REPORT_AGENCY_PERFERMANCE_OVERVIEW_PATH,
    element: (
      <React.Suspense fallback={<LoadingPage />}>
        <AgencyPerfermanceOverviewReportPage />
      </React.Suspense>
    ),
    errorElement: <FrontdeskReportBoundary />,
    handle: {
      crumb: () => (
        <Breadcrumb
          label={i18next.t('report.menu.agency_perfermance_overview' as any)}
          path={REPORT_AGENCY_PERFERMANCE_OVERVIEW_PATH}
        />
      ),
    },
  },
  {
    path: REPORT_FINANCIAL_ACCOUNT_REPORT_PATH,
    element: (
      <React.Suspense fallback={<LoadingPage />}>
        <FinancialAccountReportPage />
      </React.Suspense>
    ),
    errorElement: <FrontdeskReportBoundary />,
    handle: {
      crumb: () => (
        <Breadcrumb
          label={i18next.t('report.menu.financial_account' as any)}
          path={REPORT_FINANCIAL_ACCOUNT_REPORT_PATH}
        />
      ),
    },
  },
];
